import { defineComponent as _defineComponent } from 'vue'
import CheckInFeedback from '@/components/post-meeting/check-in-feedback.vue'
import CheckInSuccess from '@/components/post-meeting/check-in-success.vue'
import Loader from '@/components/loader.vue';
import CheckInPopup from "@/components/meeting-details/check-in-popup.vue"

import { httpsCallable } from 'firebase/functions'
import {functions} from '../util/firebase'

import { watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {ref} from 'vue'
import { checkLoggedIn } from '@/util/auth';
import { Userspaces, Meetings, DataInstance } from '@busy-human/opt-library';
enum CheckInStage {
    FEEDBACK = 1,
    SUCCESS = 2
}


export default /*#__PURE__*/_defineComponent({
  __name: 'check-in',
  setup(__props, { expose }) {
  expose();

const stage = ref(CheckInStage.FEEDBACK);

const route = useRoute();
const router = useRouter();

const noScroll = ref(false)
const loading = ref(true)
const error = ref("")

const meeting = ref<DataInstance<Meetings.Model> | null>(null)
const meetingType = ref("")

const user = ref<DataInstance<Userspaces.Model> | null>(null)


const isLoggedIn = ref(false)

const getMeetingFromLink = httpsCallable<{meetingLink: string}, DataInstance<Meetings.Model>>(functions, 'getMeetingFromLink');

watch(() => route.params.meetingLink, async meetingLink => {
    loading.value = true
    error.value = ""
    if(meetingLink) {
        try {
            let meetingData = await Meetings.Collection.fetchMeetingForLink(meetingLink as string)
            if(!meetingData || meetingData?.meeting.status === Meetings.MeetingStatus.canceled){
                loading.value = false
                return
            } 

            meetingType.value = meetingData.type
            meeting.value = meetingData.meeting as DataInstance<Meetings.Model>

            if(!checkLoggedIn()){
                if(meetingLink === meeting.value.payerLink){
                    let payer = await Userspaces.Collection.fetchDoc(meeting.value.payer)
                    if(payer.data()){
                        user.value = payer.data();
                        user.value.$id = payer.$id;                        
                    }

                }else if(meetingLink === meeting.value.collectorLink){
                    let collector = await Userspaces.Collection.fetchDoc(meeting.value.collector)
                    if(collector.data()) {
                        user.value = collector.data();
                        user.value.$id = collector.$id;                             
                    }
                }
            }
            meeting.value = meetingData.meeting as DataInstance<Meetings.Model>

        } catch(err: any) {
            console.error(err);
            alert(`An error occurred while loading this checkin: ${err.message}`);
        }
    } else {
        console.log(`No meeting link provided: ${meetingLink}`);
    }
    
    loading.value = false
}, {immediate: true})

const routeBack = () => {
    router.back()
}

const routeTo = (route:string) =>{
    router.push(`/${route}`);
}


const __returned__ = { CheckInStage, stage, route, router, noScroll, loading, error, meeting, meetingType, user, isLoggedIn, getMeetingFromLink, routeBack, routeTo, CheckInFeedback, CheckInSuccess, Loader, CheckInPopup, httpsCallable, functions, watch, useRoute, useRouter, ref, checkLoggedIn, Userspaces, Meetings, DataInstance }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})